import React from "react";
import ReactPaginate from "react-paginate";
import Loading from "../../../components/loading";

export default function ListReadingType({
    loading,
    filteredReadingTypes,
    selected,
    handleSelect,
    handleToggleStatus,
    getStatusClass,
    pageCount,
    handlePageClick,
}) {
    return (
        <div className="table-responsive">
            <table className="table table-striped table-bordered mb-0">
                <thead className="table-light">
                    <tr>
                        <th>Select</th>
                        <th>Reading Type</th>
                        <th>Status</th>
                    </tr>
                </thead>

                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan="3" className="text-center py-4">
                                <Loading />
                            </td>
                        </tr>
                    ) : filteredReadingTypes.length > 0 ? (
                        filteredReadingTypes.map((r) => {
                            const isActive = r.status === "Active";
                            return (
                                <tr key={r.id}>
                                    <td>
                                        <input
                                            type="radio"
                                            name="readingTypeSelect"
                                            disabled={!isActive}
                                            checked={selected === r.id}
                                            onChange={() => handleSelect(r.id)}
                                        />
                                    </td>
                                    <td>{r.readingType}</td>
                                    <td>
                                        <span
                                            className={`badge ${getStatusClass(r.status)}`}
                                            style={{ cursor: "pointer" }}
                                            onClick={() => handleToggleStatus(r.id, r.status)}
                                        >
                                            {r.status}
                                        </span>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="3" className="text-center text-muted">
                                No Reading Types Found.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            <ReactPaginate
                breakLabel="..."
                nextLabel="Next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={pageCount}
                previousLabel="< Previous"
                containerClassName="pagination-container mt-2"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                activeClassName="active"
            />
        </div>
    );
}
